module.exports = __webpack_public_path__ + "img/banner_2.0840f066.jpg";